// extracted by mini-css-extract-plugin
module.exports = {"animationI":"animationI_animationI__JbGdD"};